module.exports = __webpack_public_path__ + "img/0xe132ade7c63594eb3880ea12ce821407c3a4fd71.554852dd.png";